// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
//import less from "less";
import Progress from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import echarts from "echarts";
// import echartsGL from "echarts-gl";
import axios from "axios";

// Vue.prototype.$echarts = echarts;
// Vue.prototype.$echartsGL = echartsGL;
Vue.prototype.axios = axios;
// axios.defaults.baseURL = 'http://47.105.139.107:8080'
// axios.defaults.headers.post["Content-Type"] = "application/json";
// axios.defaults.headers.get["Content-Type"] = "application/json";

// Vue.use(less);
Vue.use(Progress);

Vue.config.productionTip = false;

/* eslint-disable no-new */

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});

